import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { ListItemText, Typography } from "@mui/material";
import Logo from "../assets/logo-removebg-preview.png";
import { HashLink as NavHashLink } from 'react-router-hash-link';
import { Email, Phone } from "@mui/icons-material";

const Navbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));


  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const drawerContent = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        <ListItem
          component={NavLink}
          to="/"
          exact
          activeClassName="Mui-selected"
        >
          <ListItemText primary="Home" />
        </ListItem>
        <ListItem
          component={NavHashLink}
          to="/#about-us"
          activeClassName="Mui-selected"
        >
          <ListItemText primary="About" />
        </ListItem>
        <ListItem
          component={NavHashLink}
          to="/#service"
          activeClassName="Mui-selected"
        >
          <ListItemText primary="Service" />
        </ListItem>
        <ListItem
          component={NavHashLink}
          to="/#contact"
          activeClassName="Mui-selected"
        >
          <ListItemText primary="Contact" />
        </ListItem>
      </List>
    </Box>
  );

  return (
    <>
      <div className='px-2 md:px-[5%] xl:px-[10%] flex flex-wrap items-start w-full text-white bg-[#1977CC]'>
        <IconButton href="mailto:textandvoice@digitalmediaplus.info" color="inherit" aria-label="Email us">
          <Email />
          <Typography variant="body1" component="span" className="ms-2">
            textandvoice@digitalmediaplus.info
          </Typography>
        </IconButton>
        <IconButton href="tel:+2348054629268" color="inherit" aria-label="Call us">
          <Phone />
          <Typography variant="body1" component="span" className="ms-2">
            +234 805 462 9268
          </Typography>
        </IconButton>
      </div>
      <AppBar
        position="sticky"
        sx={{ color: 'white', backgroundColor: 'white' }}
        className='px-2 md:px-[5%] xl:px-[10%]'
      >
        <Toolbar>
          <header className="flex flex-row justify-between items-center w-full">
            <div className="flex items-center">
              <a href="/">
                <img src={Logo} alt="text&voice" className="w-[50px] md:w-[80px]" />
              </a>
              <h2 className="text-[#2C4964] font-extrabold text-[20px] sm:text-[25px] md:text-[33px]">Text&Voice</h2>
            </div>
            {!isMobile && (
              <div style={{ display: 'flex', marginLeft: 'auto', gap: '5px', color: '#2C4964', justifyContent:'flex-end', }}>
                <Button
                  color="inherit"
                  component={NavLink}
                  to="/"
                  exact
                  activeClassName="Mui-selected"

                >
                  Home
                </Button>
                <Button
                  color="inherit"
                  component={NavHashLink}
                  to="/#about-us"
                  activeClassName="Mui-selected"
                >
                  About
                </Button>
                <Button
                  color="inherit"
                  component={NavHashLink}
                  to="/#service"
                  activeClassName="Mui-selected"
                >
                  Service
                </Button>
                <Button
                  color="inherit"
                  component={NavHashLink}
                  to="/#contact"
                  activeClassName="Mui-selected"
                >
                  Contact
                </Button>
              </div>
            )}
            {isMobile && (
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2, color: '#2C4964', fontWeight: '700' }}
                onClick={toggleDrawer(true)}
              >
                <MenuIcon />
              </IconButton>
            )}
          </header>
          {isMobile && (
            <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
              {drawerContent}
            </Drawer>
          )}
        </Toolbar>
      </AppBar>
    </>

  );
};

export default Navbar;
